import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/20/solid';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

/** Legacy inline toast; prefer `useToast()` from `components/ui` for new code. */
export function Toast({ message, type, onClose }: ToastProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div
        className={`flex items-center gap-2 rounded-stitch-lg px-4 py-3 shadow-stitch-pop ${
          type === 'success' ? 'bg-stitch-success text-white' : 'bg-stitch-danger text-white'
        }`}
      >
        <span className="text-sm font-medium">{message}</span>
        <button type="button" onClick={onClose} className="rounded p-0.5 hover:bg-stitch-surface/20">
          <span className="sr-only">{t('common.close')}</span>
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
